"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Root = exports.Headline = void 0;
var _mui = require("@ori-ui/mui");
var _productList = require("@ori/product-list");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme, isList } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(4),
        margin: theme.spacing(0, 3),
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(8),
            margin: 0
        },
        ...!isList && {
            [".".concat(_productList.productListClasses.root)]: {
                maxWidth: 1005
            },
            [".".concat(_productList.productListClasses.carousel)]: {
                maxWidth: 1005,
                width: '100%'
            }
        }
    };
});
const Headline = exports.Headline = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        textAlign: 'center',
        color: theme.palette.grey[900]
    };
});
